import React from 'react';
import LMSPlatform from '../components/LMSPlatform';
import Contact from '../components/Contact';
import '../styles/LMSPlatform.css';

const LMSPlatformPage: React.FC = () => {
  return (
    <>
      <LMSPlatform />
      <Contact />
    </>
  );
};

export default LMSPlatformPage;
